import Charge, { PaymentCharge } from 'app/models/charge'

export const oldCharg: Charge = {
  business_name: 'AB Wears',
  id: 'c01b1a29-3a0c-4435-af6b-50a7638cb319',
  business_id: 'ae1fe014-a086-4279-87f3-74345767843a',
  reference: 'Demo_ref_1661448332013',
  hosted_url: 'https://busha-pug-landing-staging.vercel.app',
  price_fixed: false,
  callback_url: 'http://localhost:3333/demo-response',
  public_key: 'pub_Ar5i7rySZuMRregSaCxb9',
  deeplink:
    'https:/borodev.page.link/busha_pay/charge/c01b1a29-3a0c-4435-af6b-50a7638cb319',
  meta: {
    name: 'Abolaji Bisiriyu',
    email: 'bolaji@busha.co',
    phone_number: '+234 8012345678',
  },
  expires_at: '2025-04-27T14:40:34.615317806Z',
  type: null,
  timeline: [{ status: 'NEW', created_at: '2022-08-25T17:25:34.615317806Z' }],
  supported_assets: [
    { currency_id: 'BTC', chains: [], name: 'Bitcoin', supportedNetworks: [] },
    { currency_id: 'ETH', chains: [], name: 'Ethereum', supportedNetworks: [] },
    {
      currency_id: 'USDT',
      chains: ['ETH', 'TRX'],
      name: 'USD Tether',
      supportedNetworks: [
        {
          id: 'USDTBSC',
          address_link: 'https://testnet-explorer.binance.org/tx/',
          address_regex: '^(0x)[0-9A-Fa-f]{40}$',
          is_ramp_buy_supported: false,
          is_ramp_sell_supported: false,
          max_withdrawal_amount: '0',
          min_deposit_amount: '2',
          min_withdrawal_amount: '5',
          name: 'USDT-BEP20',
          network: 'BSC',
          status: 'active',
          withdrawal_fee: '0',
        },
        {
          id: 'USDTETH',
          address_link: 'https://etherscan.io/tx/',
          address_regex: '^(0x)[0-9A-Fa-f]{40}$',
          is_ramp_buy_supported: false,
          is_ramp_sell_supported: false,
          max_withdrawal_amount: '0',
          min_deposit_amount: '2',
          min_withdrawal_amount: '5',
          name: 'USDT-ERC20',
          network: 'ETH',
          status: 'active',
          withdrawal_fee: '20',
        },
        {
          id: 'USDTTRX',
          address_link: 'https://shasta.tronscan.org/#/transaction/',
          address_regex: '^T[1-9A-HJ-NP-Za-km-z]{33}$',
          is_ramp_buy_supported: true,
          is_ramp_sell_supported: true,
          max_withdrawal_amount: '0',
          min_deposit_amount: '5',
          min_withdrawal_amount: '5',
          name: 'USDT-TRC20',
          network: 'TRX',
          status: 'active',
          withdrawal_fee: '1',
        },
      ],
    },
  ],
  payment_threshold: {
    overpayment_absolute_threshold: '0',
    overpayment_relative_threshold: '0',
    underpayment_absolute_threshold: '0',
    underpayment_relative_threshold: '0',
  },
  payments: null,
  pricing: [
    { currency_id: 'NGN', amount: '500', rate: '1' },
    { currency_id: 'BTC', amount: ' 0.0000337', rate: '14837765' },
    { currency_id: 'ETH', amount: '0.00042631', rate: '1172858' },
    { currency_id: 'USDT', amount: '0.72065839', rate: '693.81' },
  ],
  local_amount: '25',
  local_currency: 'USDT',
}

const testChargeData: PaymentCharge = {
  business_name: 'AB Wears',
  // reference: "Demo_ref_1661448332013",
  reference: '',
  callback_url: '',
  // callback_url: 'http://localhost:3333/demo-response',
  public_key: '',
  meta: { name: '', email: '', phone_number: '+234 8012345678' },
  quote_amount: '10000',
  quote_currency: 'NGN',
  source_currency: '',
}
export default testChargeData
